const actionTypes = require('constants/actionTypes');

const init = () => ({
    type: actionTypes.CUSTOM_WALLET_INIT
});

module.exports = {
    init
};
